import { render, staticRenderFns } from "./OrderStatuses.vue?vue&type=template&id=041ba3f4&"
import script from "./OrderStatuses.vue?vue&type=script&lang=ts&"
export * from "./OrderStatuses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports